export enum BuildTripReorderMapSaveType {
  Update_NotRequired = 1,
  Update_Yes_InPayload = 2,
  Update_Yes_InPayloadAndInStore = 3,
  Update_No_InPayload = 4,
  Update_No_InPayload_Yes_InStore = 5
}
